import Req, { OpsBackend } from "./request";
import UReq from "../page/usms/utils/ucloudRequest";

import Config, { GetEnv } from "../utils/config";
import { RecordTypeId } from "../page/usms/utils/const";
// import { GetSelfPermissions } from './acl';
import Auth from "../utils/auth";
import { getSignatureParams } from "../page/usms/utils/getSignatureParams";

import { getSmsType } from "../page/localStorage";

/* 运营平台API */
function UsmsOpsFetch(action, params, getResult, adminAction) {
  return Req({
    method: "post",
    baseURL: "",
    url: Config.OpsAPI[GetEnv()],
    timeout: 60000,
    data: {
      Action: action,
      AdminAction: adminAction,
      SMSCategory: getSmsType() || "Text",
      ...params
    },
    headers: { remote_user: Auth.getLocalAuthName() }
  }).then(res => {
    return getResult ? getResult(res) : res;
  });
}

/* 短信包业务方API */
function UsmsFetch(action, params, getResult, adminAction) {
  const data = {
    Action: action,
    SMSCategory: getSmsType() || "Text",
    Backend: OpsBackend.UsmsBackend,
    AdminAction: adminAction,
    ...params
  };

  if (adminAction) {
    delete data.Backend;
  }
  return Req({
    method: "post",
    url: Config.OpsAPI[GetEnv()],
    timeout: 60000,
    headers: { remote_user: Auth.getLocalAuthName() },
    data
  }).then(res => {
    return getResult ? getResult(res) : res;
  });
}

/* ucloud API 废弃，uspeedo要用uspeedo的API */
function UcloudFetch(action, params) {
  const data = getSignatureParams({
    Action: action,
    Backend: "nobackend",
    ...params
  });
  return UReq({
    method: "post",
    url: Config.OpsAPI[GetEnv()],
    data
  });
}

/* 短信包acl */
export const USMSGetSelfPermissions = () =>
  Req({
    method: "post",
    baseURL: "",
    url: Config.OpsAPI[GetEnv()],
    data: {
      Action: "GetSelfPermissions",
      namespace: "usms_ops",
      Backend: OpsBackend.UaclBackend
    },
    headers: { remote_user: Auth.getLocalAuthName() }
  }).then(res => {
    return (res && res.Permissions) || [];
  });

/* 运营平台Action */
export const GetUserInfo = params => UsmsOpsFetch("GetUserInfo", params, res => (res && res.Data) || {});
export const GetDataReport = params =>
  UsmsOpsFetch("GetDataReport", params, res => (res && res.Data && res.Data.List) || []);
export const GetManagerDataReport = params =>
  UsmsOpsFetch("GetManagerDataReport", params, res => (res && res.Data && res.Data.List) || []);
export const GetCompanyDataReportDetail = params =>
  UsmsOpsFetch("GetCompanyDataReportDetail", params, res => (res && res.Data && res.Data.List) || []);
export const GetCompanyBuyRecord = params =>
  UsmsOpsFetch("GetCompanyBuyRecord", params, res => (res && res.Data && res.Data.List) || []);
export const GetCost = params => UsmsOpsFetch("GetCost", params, res => (res && res.Data) || {});
export const GetRevenue = params => UsmsOpsFetch("GetRevenue", params, res => (res && res.Data) || {});
export const GetCostStatistics = params =>
  UsmsOpsFetch("GetCostStatistics", params, res => (res && res.Data && res.Data.List) || []);
export const GetCustomerExtendInfoList = params =>
  UsmsOpsFetch("GetCustomerExtendInfoList", params, res => (res && res.Data && res.Data.List) || []);
// 客户统计
export const GetCustomerStatistics = params =>
  UsmsOpsFetch("GetCustomerStatistics", params, res => (res && res.Data && res.Data.List) || []);

/* 短信包业务方Action */
// 客户列表
export const DescribeUSMSCustomer = params => UsmsFetch("DescribeUSMSCustomer", params, res => (res && res.Data) || []);
//
export const DescribeCountryRegion = params =>
  UsmsFetch("DescribeCountryRegion", params, res => (res && res.Data) || []);
// 签名列表
export const DescribeUSMSSignature = params =>
  UsmsFetch("DescribeUSMSSignature", params, res => (res && res.Data) || []);
// 签名详情
export const GetUSMSSignatureDetail = params =>
  UsmsFetch("GetUSMSSignatureDetail", params, res => (res && res.Data) || {});
// 签名审核内容模版
export const DescribeAuditSignatureTemplate = params =>
  UsmsFetch("DescribeAuditSignatureTemplate", params, res => (res && res.Data) || []);
// 签名审核
export const UpdateUSMSSignatureStatus = params =>
  UsmsFetch("UpdateUSMSSignatureStatus", params, res => (res && res.Data) || {});

// 模版列表
export const DescribeUSMSTemplate = params => UsmsFetch("DescribeUSMSTemplate", params, res => (res && res.Data) || []);
// 模版详情
export const GetUSMSTemplateDetail = params =>
  UsmsFetch("GetUSMSTemplateDetail", params, res => (res && res.Data) || {});
export const DescribeUSMSTemplateWithRisk = params =>
  UsmsOpsFetch("GetActionWithCompanySelfRisk", params, res => (res && res.Data) || {}, "DescribeUSMSTemplate");
// 模版审核内容模版
export const DescribeAuditTemplate = params =>
  UsmsFetch("DescribeAuditTemplate", params, res => (res && res.Data) || []);
// 模版审核
export const UpdateUSMSTemplateStatus = params =>
  UsmsFetch("UpdateUSMSTemplateStatus", params, res => (res && res.Data) || {});
// 发送数据统计
export const DescribeSendStatistics = params =>
  UsmsFetch("DescribeSendStatistics", params, res => (res && res.Data) || []);

// 客户提交记录
export const DescribeCustomerSubmitRecord = params => UsmsFetch("DescribeCustomerSubmitRecord", params);
// 短信提交记录
export const DescribeSubmitRecord = params => UsmsFetch("DescribeSubmitRecord", params);
// 短信上行记录
export const DescribeReportRecord = params => UsmsFetch("DescribeReportRecord", params);

// 短信发送记录
export const DescribeSendRecord = params => UsmsFetch("DescribeSendRecord", params);
export const DescribeQueryRecord = params => UsmsFetch("DescribeQueryRecord", params);

// 通过网关调用console上的API
export const SendUSMSMessage = params => UcloudFetch("SendUSMSMessage", params);
export const GetUSMSSendTask = params => UcloudFetch("GetUSMSSendTask", params);

// 通道调度
export const DescribeChannelControl = params => UsmsFetch("DescribeChannelControl", params);
export const GetDispatchConfigDetail = params => UsmsOpsFetch("GetDispatchConfigDetail", params);
export const DescribeUSMSChannel = params => UsmsFetch("DescribeUSMSChannel", params);
export const UpdateChannelControl = params => UsmsFetch("UpdateChannelControl", params);
export const CreateChannelControl = params => UsmsFetch("CreateChannelControl", params);
export const DescribeChannelEndpointProvince = params => UsmsFetch("DescribeChannelEndpointProvince", params);
export const ReplaceChannelControl = params => UsmsFetch("ReplaceChannelControl", params);
export const ReplaceChannelControlReview = params => UsmsFetch("ReplaceChannelControlReview", params);
export const DescribeChannelControlWithRisk = params => UsmsFetch("GetActionWithCompanySelfRisk", params, null, 'DescribeChannelControl');

// 操作日志
export const AddLogRecord = params => UsmsOpsFetch("AddLogRecord", params);
export const addChannelRecord = params => {
  const data = {
    RecordTypeId: RecordTypeId.ChannelConfig,
    ...params
  };
  AddLogRecord(data);
};

//
export const GetSendStatistics = params => UsmsOpsFetch("GetSendStatistics", params, res => res && res.Data);

// 获取风险信息
export const GetCustomerWithRisk = params => UsmsOpsFetch("GetCustomerWithRisk", params);

// 获取所有用户
export const GetCompanyList = params => {
  return UsmsOpsFetch("GetCompanyList", params)
}
// 账户升级
export const UpgradeCompany = params => {
  return UsmsOpsFetch("UpgradeCompany", params)
}
// 赠金发放
export const AddFreeAmount = params => {
  return UsmsOpsFetch("AddFreeAmount", params)
}
export const CancelFreeAmount = params => {
  return UsmsOpsFetch("CancelFreeAmount", params)
}
// 账户充值
export const AddInnerInpourTrade = params => {
  return UsmsOpsFetch("AddInnerInpourTrade", params)
}

// 信用额度
export const SetAccountCredit = params => {
  return UsmsOpsFetch("SetAccountCredit", params)
}

export const GetCustomerList = params => {
  return UsmsOpsFetch("GetCustomerList", params)
}

export const GetCustomerDetail = params => {
  return UsmsOpsFetch("GetCustomerDetail", params)
}

// 客户发送统计
export const GetCustomerSendStats = params => UsmsOpsFetch('GetCustomerSendStats', params);
// export const GetCustomerStatistics = params => UsmsOpsFetch('GetCustomerStatistics', params);

export const PreviewUSMSTemplateInfo = (params) => UsmsFetch('PreviewUSMSTemplateInfo', params);

export const CreateCustomer = params => {
  return UsmsOpsFetch("CreateCustomer", params)
}

export const GetSalespersonList = params => {
  return UsmsOpsFetch("GetSalespersonList", params)
}